/* Read state from Dawn; delegate purchasing to its single original submit button. */
if (!customElements.get('yawbay-sticky-cart')) {
  customElements.define('yawbay-sticky-cart', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('product-info');
      this.info = this.root?.querySelector(`#ProductInfo-${CSS.escape(this.dataset.section)}`);
      if (!this.info) return;
      this.action = this.querySelector('[data-sticky-submit]');
      this.variantLabel = this.querySelector('[data-sticky-variant]');
      this.price = this.querySelector('[data-sticky-price]');
      this.errorLabel = this.querySelector('[data-sticky-error]');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.action.addEventListener('click', () => this.purchase(), options);
      this.querySelector('[data-edit-selection]').addEventListener('click', () => this.reviewOptions(), options);
      this.info.addEventListener('change', () => this.schedule(), options);
      this.observer = new MutationObserver(() => this.schedule());
      this.observer.observe(this.info, { childList: true, subtree: true, attributes: true, characterData: true });
      window.addEventListener('scroll', () => this.schedule(), { ...options, passive: true });
      window.addEventListener('resize', () => this.schedule(), options);
      this.sync();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      document.body.classList.remove('yb-sticky-visible');
      document.body.style.removeProperty('--yb-sticky-offset');
    }
    schedule() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); });
    }
    get mainButton() {
      return this.info.querySelector(`#ProductSubmitButton-${CSS.escape(this.dataset.section)}`);
    }
    get mainForm() {
      return this.info.querySelector(`#product-form-${CSS.escape(this.dataset.section)}`);
    }
    requiresReview() {
      // App-provided properties must be completed and validated in their original UI.
      return this.dataset.reviewOptions === 'true' || Array.from(this.mainForm?.elements || []).some(input => input.name?.startsWith('properties['));
    }
    sync() {
      const button = this.mainButton;
      const variantId = this.mainForm?.querySelector('[name="id"]')?.value;
      const busy = button?.getAttribute('aria-disabled') === 'true' || button?.classList.contains('loading');
      this.action.disabled = !button || button.disabled || busy || !variantId;
      this.action.setAttribute('aria-busy', String(!!busy));
      this.action.textContent = !this.action.disabled && this.requiresReview()
        ? this.dataset.optionsLabel : button?.querySelector('span')?.textContent.trim() || this.dataset.addLabel;
      const price = this.info.querySelector(`#price-${CSS.escape(this.dataset.section)}`);
      const priceHtml = price?.classList.contains('hidden') ? '' : price?.innerHTML || '';
      if (this.price.innerHTML !== priceHtml) this.price.innerHTML = priceHtml;
      // Only the server-rendered selected variant is read; no full variants array is loaded.
      let selected;
      try { selected = JSON.parse(this.info.querySelector('[data-selected-variant]')?.textContent || 'null'); } catch { selected = null; }
      this.variantLabel.textContent = selected?.title && selected.title !== 'Default Title' ? selected.title : '';
      const error = this.info.querySelector('.product-form__error-message-wrapper:not([hidden]) .product-form__error-message')?.textContent || '';
      this.errorLabel.textContent = error;
      this.errorLabel.hidden = !error;
      this.hidden = !(matchMedia('(max-width: 749px)').matches && button && button.getBoundingClientRect().bottom < 0);
      document.body.classList.toggle('yb-sticky-visible', !this.hidden);
      const offset = Math.min(120, Math.max(0, Number(this.dataset.bottomOffset) || 0));
      document.body.style.setProperty('--yb-sticky-offset', `${offset}px`);
    }
    reviewOptions() {
      const target = this.info.querySelector('variant-selects') || this.mainForm || this.info;
      target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
      const input = target.querySelector('input:not([type="hidden"]),select,button');
      input?.focus({ preventScroll: true });
    }
    purchase() {
      this.sync();
      if (this.action.disabled) return;
      if (this.requiresReview()) { this.reviewOptions(); return; }
      const form = this.mainForm;
      if (!form || !form.reportValidity()) { this.reviewOptions(); return; }
      // A real click preserves Dawn, Globo, quantity, properties and cart integrations.
      this.mainButton.click();
      this.schedule();
    }
  });
}
